// One shared socket.io connection to our own live server (socket.wanshow.bingo).
//
// Singleton on purpose. The server derives the live-viewer number from the
// number of CONNECTIONS, so opening a second connection per browser would
// visibly double the count on everyone's card. Both consumers -- the card
// (viewer count + confirmed-square glow) and the notification toaster --
// subscribe to this one socket and remove only their own listeners on cleanup.
import io from 'socket.io-client';

export const LIVE_SOCKET_URL = 'https://socket.wanshow.bingo:3015';

// The same state the socket pushes on connect, as one plain GET, served by the
// same process (server-backend/web-socket.js, handlePublicRequest). A page that
// has only just opened asks for this at the moment it opens the socket, so it is
// never left blank waiting on a handshake -- and it is still right on a network
// that quietly drops a non-standard port.
export const LIVE_SNAPSHOT_URL = `${LIVE_SOCKET_URL}/api/live-snapshot`;

let socket = null;

export default function getLiveSocket() {
  if (!socket) {
    socket = io(LIVE_SOCKET_URL);
    socket.on('connect', () => console.log('Connected to the server'));
    socket.on('disconnect', () => console.log('Disconnected from the server'));
  }
  return socket;
}

// Square text is typed by hand in the admin panel and rendered verbatim on the
// card. Compare on a normalised form so a stray space or a capital letter never
// costs a player their indicator.
export function normalizeTile(s) {
  return String(s === null || s === undefined ? '' : s).trim().replace(/\s+/g, ' ').toLowerCase();
}
